<template>
  <div :class="classes">
      <el-input v-model="min_price" type="number" :min="0" @change="minPriceChange" class="number-input-price"
      :placeholder="minPlaceholder" :clearable="clearable">
          <el-button slot="append" v-if="type=='price'">¥</el-button>
        </el-input>
      <div class="price-line" >--</div>
      <el-input  v-model="max_price"  type="number" :min="0" @change="maxPriceChange" class="number-input-price"
      :placeholder="maxPlaceholder" :clearable="clearable">
          <el-button slot="append" v-if="type=='price'">¥</el-button>
          </el-input>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-price-slot'

export default {
  name: 'pt-price-slot',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    type: {
      type: String,
      default: 'price'
    },
    minPrice: {
      type: [String, Number],
      default: ''
    },
    maxPrice: {
      type: [String, Number],
      default: ''
    },
    minLabel: {
      type: String,
      default: 'minPrice'
    },
    maxLabel: {
      type: String,
      default: 'maxPrice'
    },
    maxPlaceholder: {
      type: String,
      default: '价格'
    },
    minPlaceholder: {
      type: String,
      default: '价格'
    },
    clearable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      min_price: this.minPrice,
      max_price: this.maxPrice,
      data: {}
    }
  },
  watch: {
    minPrice (val) {
      if (!val) {
        this.min_price = val
      }
    },
    maxPrice (val) {
      if (!val) {
        this.max_price = val
      }
    }
  },
  methods: {
    minPriceChange (val) {
      if (val) {
        if (Number(val) < 0) {
          this.$message.error('请填写大于0的数字')
          this.min_price = ''
        } else if (this.max_price && Number(this.max_price) < Number(val)) {
          this.$message.error('请填写小于最大值的数字')
          this.min_price = ''
        } else {
          this.data[this.minLabel] = val
          this.data[this.maxLabel] = this.max_price
          this.$emit('change', this.data)
        }
      } else {
        this.data[this.minLabel] = val
        this.data[this.maxLabel] = this.max_price
        this.$emit('change', this.data)
      }
    },
    maxPriceChange (val) {
      if (val) {
        if (Number(val) < 0) {
          this.$message.error('请填写大于0的数字')
          this.max_price = ''
        } else if (this.min_price && Number(this.min_price) > Number(val)) {
          this.$message.error('请填写大于最小值的数字')
          this.max_price = ''
        } else {
          this.data[this.maxLabel] = val
          this.data[this.minLabel] = this.min_price
          this.$emit('change', this.data)
        }
      } else {
        this.data[this.maxLabel] = val
        this.data[this.minLabel] = this.min_price
        this.$emit('change', this.data)
      }
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
<style lang="less" scoped>
.pt-price-slot{
    display: flex;

.number-input-price{
    width: 150px;
    .el-input-group__append{
        padding: 0;
    .el-button{
        margin: -10px -20px;
        padding: 10px
    }
    }
}

.price-line{
    line-height:40px;
    color:#E0E2E8;
    padding:0 10px;
    white-space: nowrap;
}

}
</style>
<style lang="less">
.pt-price-slot{
    input[type="number"] {
    -moz-appearance: textfield!important;
    &::-webkit-outer-spin-button,&::-webkit-inner-spin-button{
    -webkit-appearance: none;
    }
    }
}
</style>
